// White-label brand. Everything on screen that names the product reads from
// here; set REACT_APP_BRAND_* at build time (see BRANDING.md). Defaults are
// EliyaQ's own, so an unconfigured build is unchanged.
const env = process.env;

const name = env.REACT_APP_BRAND_NAME || "EliyaQ";

const BRAND = {
  name,
  // Short form for tight spots (sidebar header, installed-app label).
  short: env.REACT_APP_BRAND_SHORT || name,
  // Two-tone wordmark on the login page: e.g. "Eliya" + "Q". When no split is
  // configured the whole name is shown in one colour.
  lead: env.REACT_APP_BRAND_LEAD !== undefined ? env.REACT_APP_BRAND_LEAD : (env.REACT_APP_BRAND_NAME ? name : "Eliya"),
  tail: env.REACT_APP_BRAND_TAIL !== undefined ? env.REACT_APP_BRAND_TAIL : (env.REACT_APP_BRAND_NAME ? "" : "Q"),
  tagline: env.REACT_APP_BRAND_TAGLINE !== undefined ? env.REACT_APP_BRAND_TAGLINE : "SMART QUEUE MANAGEMENT",
  slug: name.toLowerCase().replace(/[^a-z0-9]+/g, ""),
  companion: `${env.REACT_APP_BRAND_SHORT || name} Companion`,
  // Optional logo images in /public (e.g. "brand-logo-full.png"): the full
  // lockup replaces the mark + wordmark on the login page; the mark replaces
  // the sidebar icon. Unset = the built-in EliyaQ mark.
  // Login screen: "waves" (default, EliyaQ) or "bands" (straight lines in the
  // two brand colours below). SSO button can be hidden per brand.
  loginStyle: env.REACT_APP_BRAND_LOGIN_STYLE || "waves",
  sso: env.REACT_APP_BRAND_SSO !== "false",
  // The row of feature highlights under the sign-in card; "false" hides it.
  // "modern" = redesigned facility dashboard + dark branded sidebar.
  dashboard: env.REACT_APP_BRAND_DASHBOARD || "classic",
  // English-only brand: hides language options in Settings.
  englishOnly: env.REACT_APP_BRAND_ENGLISH_ONLY === "true",
  // false hides everything about messaging clients from the queue (FAQ / Messages page,
  // Conversation Log tab, "Message patient" buttons). On unless a brand turns it off.
  messaging: env.REACT_APP_BRAND_MESSAGING !== "false",
  // The redesigned Reports tabs (Daily overview, Trends & Analysis, Categories & Traffic, exports).
  // On by default; REACT_APP_BRAND_REPORTS=classic keeps the older tabs.
  reportsRedesign: env.REACT_APP_BRAND_REPORTS !== "classic",
  loginFeatures: env.REACT_APP_BRAND_LOGIN_FEATURES !== "false",
  // "bold" makes the copyright/footer line heavier and darker.
  loginFooter: env.REACT_APP_BRAND_LOGIN_FOOTER || "normal",
  colorPrimary: env.REACT_APP_BRAND_COLOR_PRIMARY || "#2563EB",
  colorAccent: env.REACT_APP_BRAND_COLOR_ACCENT || "#F59E0B",
  logoFull: env.REACT_APP_BRAND_LOGO_FULL || "",
  logoMark: env.REACT_APP_BRAND_LOGO_MARK || "",
};

export default BRAND;
